import { Component } from '@angular/core';
//import { FcmService } from './services/fcm/fcm.service';

@Component({
  selector: 'app-root',
  templateUrl: 'app.component.html',
  styleUrls: ['app.component.scss'],
})
export class AppComponent {
  constructor( /*private _fcm: FcmService*/ ) { 
    // Iniciamos las push notificatión al inicar la App.
    //this._fcm.initPush();
  }
}
